import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-[#0f1a14] text-[#f5f0e8] font-sans overflow-x-hidden selection:bg-emerald-500/30 selection:text-emerald-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedSolutions data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}